import { Eye, X } from "lucide-react";
import { useState } from "react";
import { useSite } from "@/context/SiteContext";

export default function PreviewBanner() {
  const { isPreview } = useSite();
  const [hidden, setHidden] = useState(false);
  if (!isPreview || hidden) return null;

  const turnOff = () => {
    sessionStorage.removeItem("influcas_preview");
    const url = new URL(window.location.href);
    url.searchParams.delete("preview");
    window.location.href = url.toString();
  };

  return (
    <div className="bg-primary text-primary-foreground" data-testid="preview-banner">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-10 flex items-center justify-between text-xs font-semibold">
        <div className="flex items-center gap-2">
          <Eye className="w-3.5 h-3.5" />
          <span>MODO PREVIEW · Estás viendo todas las secciones (incluso las ocultas en navegación)</span>
        </div>
        <div className="flex items-center gap-3">
          <button onClick={turnOff} className="opacity-80 hover:opacity-100 underline">Salir del preview</button>
          <button onClick={() => setHidden(true)} className="opacity-80 hover:opacity-100"><X className="w-3.5 h-3.5" /></button>
        </div>
      </div>
    </div>
  );
}
